import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

function GlandsAccessories() {
    const [active, setActive] = useState("Safe Area");
    const navigate = useNavigate();
    return (
        <>
        <Helmet>
                <title>
                    Cable Glands & Accessories UAE | Cable Protection Solutions | Al Ibtekar
                </title>

                <meta
                    name="description"
                    content="Al Ibtekar supplies cable glands, hazardous area cable glands, multi cable transit systems, cable cleats, sleeving, ties, markers, cable joints, heat shrink sleeves, plugs and connectors across the UAE."
                />

                <meta
                    name="keywords"
                    content="cable accessories UAE, cable glands UAE, cable glands supplier UAE, hazardous area cable glands UAE, multi cable transit system UAE, cable cleats UAE, cable sleeving UAE, cable ties UAE, cable markers UAE, cable joints UAE, heat shrink sleeves UAE, cable plugs and connectors UAE"
                />

                <meta
                    name="robots"
                    content="index, follow"
                />

                <link
                    rel="canonical"
                    href="https://saig.me/GlandsAccessories"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Cable Glands & Accessories UAE | Cable Protection Solutions | Al Ibtekar"
                />

                <meta
                    property="og:description"
                    content="Explore cable glands, hazardous area cable glands, cable transit systems, cleats, sleeving, ties, markers, joints and heat shrink solutions from Al Ibtekar UAE."
                />

                <meta
                    property="og:url"
                    content="https://saig.me/GlandsAccessories"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:site_name"
                    content="Al Ibtekar"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Cable Glands & Accessories UAE | Al Ibtekar"
                />

                <meta
                    name="twitter:description"
                    content="Cable glands, hazardous area glands, cable cleats, transit systems, cable ties, markers, joints and heat shrink accessories for electrical installations in the UAE."
                />
            </Helmet>

            <div className='newbanner-about newbanner-about3'>
                <div className="max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
                    <h6 className="font-[500] font-kanit lg:text-[60px] text-[30px] lg:leading-[90px] leading-[40px] text-[#FFFFFF] lg:pb-[14px] pb-[4px]">Cable Accessories</h6>
                    <p className="lg:max-w-[582px] max-w-[250px] w-full font-[300] font-inter lg:text-[20px] text-[12px] lg:leading-[30px] leading-[16px] text-[#FFFFFF]">Seamless cable entry with secure sealing and strain relief.
                    </p>
                </div>
            </div>
           
              <div className='newbg'>

               <div className='max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] overflow-hidden allheader mb-[20px]'>
  {/* <h2>Junction Box & Enclosures - Safe Area</h2>
  <div className='line'></div> */}
<h2>Cable Accessories</h2>
  <div className='line'></div>
                         <h3 className='text-left mb-[20px]'>High-quality cable accessories form an integral part of any cable project, and as your cable supplier we are ideally positioned to advise you on the right cable accessories to ensure the design integrity of your electrical systems. Whether in industry, mechanical engineering, or classic electrical installation, suitable components such as cable glands, multi cable transit system, cable protection, cable securing & bundling, marking systems etc. are the basis for safe, efficient, and standard-compliant cable installation. A small part of our range is listed below, but feel free to get in touch and seek our team assistance on your extended requirements.</h3>


               </div>
               </div>

            <div className='detail-div max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px] pb-[0px]'>

                <div className='detail-div-left'>
                    
                    <div className='main-img'>

                        <img src='/assets/saigacc.png' />
                    </div>


                </div>




                <div className='detail-div-right'>
                 <ul className="mt-4 grid grid-cols-1 gap-1">
                       {[
                         " Industrial Cable Glands",
                         "Hazardous Area Cable Glands",
                         "Multi Cable Transit System",
                         "Cable Cleats",
                         "Cable Sleeving",
                         "Cable Ties",
                         "Cable Markers",
                         "Cable Joints",
                         "Heat Shrink Sleeves",
                         "Plugs & Connectors",

                        
                       ].map((item, i) => (
                          <li
              key={i}
              className="flex items-start gap-3 rounded-lg  bg-white px-4   transition"
            >
              <span className="mt-1 text-[#e09e0f] text-sm font-semibold">●</span>
              <span className="text-gray-700 text-[18px] leading-relaxed text-left aplus">
                {item}
              </span>
            </li>
                       ))}
                     </ul>
               
                     <Link to="/product">
                       <button className="backbtn mt-6">
                         Back To Products
                       </button>
                     </Link>
                </div>
            </div>
            <br/>
            <br/>
           
        </>
    )
}

export default GlandsAccessories